// const API_BASE_URL = "http://localhost:5000";
const API_BASE_URL = "https://devapi.pretriptruck.com";

// const API_BASE_URL = "https://api.pretriptruck.com";

const AppConstants: any = {
  ADMIN_LOGIN_API: `${API_BASE_URL}/driver/login`,
  ADMIN_VERIFY_OTP_API: `${API_BASE_URL}/admin/verify-otp`,
  ADMIN_RESEND_OTP_API: `${API_BASE_URL}/admin/resend-otp`,
  ADMIN_PROFILE_API: `${API_BASE_URL}/admin/get-profile`,
  ADMIN_EDIT_PROFILE_API: `${API_BASE_URL}/admin/edit-profile`,
  ADMIN_CHANGE_PASSWORD_API: `${API_BASE_URL}/admin/change-password`,

  ADMIN_GET_PROMOCODES_API: `${API_BASE_URL}/promocodes`,
  ADMIN_GET_SINGLE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_CREATE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_UPDATE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,
  ADMIN_DELETE_PROMOCODE_API: `${API_BASE_URL}/promocodes`,

  ADMIN_GET_PRICES_API: `${API_BASE_URL}/pricing`,
  ADMIN_EDIT_PRICES_API: `${API_BASE_URL}/pricing/bulk`,

  PLAN_DETAILS_FEATURES_API: `${API_BASE_URL}/plan-details`,
  // ADMIN_POST_PLAN_DETAILS_API: `${API_BASE_URL}/plan-details/save`,

  ADMIN_USER_MANAGEMENT_API: `${API_BASE_URL}/user-management`,

  ADMIN_GET_ALL_PAYMENT_HISTORY: `${API_BASE_URL}/user-management/payment-transactions`,

  PRICING_BY_LICENSES_API: `${API_BASE_URL}/pricing/by-licenses`,

  PROMOCODE_REDEEM_API: `${API_BASE_URL}/promocodes/redeem`,

  ADMIN_DASHBOARD: `${API_BASE_URL}`,
  STRIPE_PUBLISHABLE_KEY:
    (process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY as string) ||
    "pk_test_51RTCDn2KQcfKtcJU4FAaSB1EmeC6ggDN549fAhvI96weWIb3BBpSzzi8Tr6pGEOJt54QRT6wTrfbwizSCGMbLtSL00ZWLomPhn"
};

AppConstants.PAYMENTS_SETUP_INTENT_API = `${API_BASE_URL}/payment-methods/setup-intent`;

AppConstants.PAYMENTS_ADD_PAYMENT_METHOD_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_LIST_METHODS_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_DELETE_METHOD_API = `${API_BASE_URL}/payment-methods`;
AppConstants.PAYMENTS_SET_DEFAULT_METHOD_API = `${API_BASE_URL}/payment-methods/default`;
AppConstants.PAYMENTS_MAKE_PAYMENT_API = `${API_BASE_URL}/api/payments/make-payment`;

AppConstants.SUBSCRIPTION_CREATE_API = `${API_BASE_URL}/subscription`;
AppConstants.SUBSCRIPTION_UPDATE_API = `${API_BASE_URL}/subscription`;
AppConstants.SUBSCRIPTION_TOGGLE_AUTO_RENEW_API = `${API_BASE_URL}/subscription/toggle-auto-renew`;
AppConstants.SUBSCRIPTION_PRORATED_AMOUNT_API = `${API_BASE_URL}/subscription/prorated-amount`;
AppConstants.SUBSCRIPTION_CANCEL_API = `${API_BASE_URL}/subscription/cancel`;
AppConstants.SUBSCRIPTION_DOWNGRADE_API = `${API_BASE_URL}/subscription/downgrade`;
AppConstants.SUBSCRIPTION_CANCEL_DOWNGRADE_API = `${API_BASE_URL}/subscription/cancel-downgrade`;
AppConstants.MEMBER_STATUS_UPDATE_API = `${API_BASE_URL}/license/members`;
AppConstants.LICENSE_USAGE_API = `${API_BASE_URL}/license/usage`;
AppConstants.LICENSE_USERS_API = `${API_BASE_URL}/license/users`;

AppConstants.LICENSE_USER_INVITE = `${API_BASE_URL}/license/invite`;

AppConstants.DRIVER_PROFILE_API = `${API_BASE_URL}/profile`;

export default AppConstants;
